import { isOnSale } from '@/modules/product/helpers/isOnSale';
import {
  type BackendProductStatus,
  type LegacyProductStatus,
  type ProductStatus,
} from '@/modules/product/types';

export function isProductOnSale(
  status?: LegacyProductStatus | BackendProductStatus | ProductStatus | string
) {
  if (!status) {
    return true;
  }
  return isOnSale(status);
}
